const components = {
  HeaderSetting: {
    changethepassword: "เปลี่ยนรหัสผ่าน",
    logout: "ออกจากระบบ",
    enter1: "กรุณากรอกรหัสผ่านเดิม",
    enter2: "กรุณากรอกรหัสผ่านใหม่ของคุณ",
    enter3: "โปรดป้อนรหัสผ่านใหม่อีกครั้ง",
    confirm: "Confirm",
    cancel: "Cancel",
    error1: "กรุณากรอกรหัสผ่านเดิม",
    error2: "กรุณากรอกรหัสผ่านใหม่ของคุณ",
    error3: "ความยาวรหัสผ่านขั้นต่ำคือ 6 หลัก",
    error4: "รหัสผ่านที่ป้อนไม่สอดคล้องกัน",
    error5: "โปรดป้อนรหัสผ่านใหม่อีกครั้ง",
    message1: "เปลี่ยนรหัสผ่านสำเร็จ",
    message2: "การเปลี่ยนรหัสผ่านล้มเหลว",
    inputlabelwidth: "225px"
  }
} 
export default components